import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Link from "~/components/Link"
import ErrorText from "~/components/Form/ErrorText"
import Checkbox from '~/components/Form/Checkbox'

const TermsContainer = styled.div`
  display: flex;
  width: 100%;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 0.8rem;
  line-height: 1rem;
  color: ${props => props.theme.colors.text.label};
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  text-align: left;
  flex-grow: 1;
  padding: 0 2rem 2rem 2rem;
  ${props => props.theme.media.mobile`
    padding: 1rem 0 1rem 0;
  `}
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const LeftSide = styled.div`
  margin-right: 10px;
`

@inject(all => ({
  payment: all.store.payment,
  agreedToTermsOfService: all.store.payment.agreedToTermsOfService,
  toggleAgreedToTerms: all.store.payment.toggleAgreedToTerms,
  tosError: all.store.payment.tosError,
  isTosRequired: all.store.payment.isTosRequired,
  isPayFlow: all.store.parkingFlow.flow.isPayFlow
}))
@observer
class TermsOfServiceAgreement extends Component {
  constructor(props) {
    super(props)
    this.dispose = null
  }

  componentDidMount = () => {
    // If we arrive with TOS already agreed, reset it so the user must toggle the control.
    if (this.props.agreedToTermsOfService) {
      this.props.toggleAgreedToTerms()
    }
  }

  componentWillUnmount() {
    if (this.dispose) {
      this.dispose()
    }
  }

  render() {
    const { payment, actionText } = this.props
    return (
      <TermsContainer>
        {this.props.isTosRequired ? (
            // For the pay flow, we show a checkbox
          <Container onClick={this.props.toggleAgreedToTerms}>
            <LeftSide>
              <Checkbox
                checked={this.props.agreedToTermsOfService}
                error={this.props.tosError}
              />
            </LeftSide>
            {this.props.isPayFlow ? (
              <div>
                You accept our{" "}
                <Link target="_blank" href="https://www.appwinit.com/terms-of-use">
                  Terms and Conditions
                </Link> and{" "}
                <Link target="_blank" href="https://www.appwinit.com/privacy-policy">
                  Privacy Policy
                </Link>
                .<br />
                You understand that Winit is a privately held company which charges the fees for the services that are listed on the payments page. Alternative low or no fee options may be available. Winit is not affiliated, associated, authorized, endorsed by, or in any way officially connected with any city, county or state government agency.
              </div>
              ): (
                <div>
                  By selecting {actionText} you acknowledge that you are creating a WinIt account and agree to be bound by our {" "}
                  <Link target="_blank" href="https://www.appwinit.com/terms-of-use">
                    Terms of Use
                  </Link>
                  {" and "}
                  <Link target="_blank" href="https://www.appwinit.com/privacy-policy">
                    Privacy Policy
                  </Link>
                </div>
            )}
          </Container>
        ) : null}
        <ErrorText hasError error={this.props.tosError} />
      </TermsContainer>
    )
  }
}

export default TermsOfServiceAgreement
